// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {
  OrganizationList_ACTION_TYPE,
  setdataAction,
} from './organizationReducer'
import { takeEvery, put, all, fork } from 'redux-saga/effects'
import { GET_ORGANIZATION_API } from '../../api/CommonApi'
function* alltask() {
  // 监听 初始化 搜索 分页 拉取数据
  yield takeEvery(OrganizationList_ACTION_TYPE.GET_DATA, getdata)
}

// 组织列表
function* getdata() {
  const data = yield GET_ORGANIZATION_API({
    canBeShipper: undefined,
    canBeUseOrg: undefined,
  })
  if (data.code === 0) {
    const resdata = data.data
    const newdata = resdata.map((item: any) => ({
      title: item.name,
      value: item.code,
    }))
    const action = setdataAction(newdata)
    yield put(action)
  }
}

// 导出当前模块的saga处理方法
export default function* jobmanagementsagas() {
  yield all([
    fork(alltask),
    // fork(setTest3),
  ])
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {
  OrganizationList_ACTION_TYPE,
  setdataAction,
} from './organizationReducer'
import { takeEvery, put, all, fork } from 'redux-saga/effects'
import { GET_ORGANIZATION_API } from '../../api/CommonApi'
function* alltask() {
  // 监听 初始化 搜索 分页 拉取数据
  yield takeEvery(OrganizationList_ACTION_TYPE.GET_DATA, getdata)
}

// 组织列表
function* getdata() {
  const data = yield GET_ORGANIZATION_API({
    canBeShipper: undefined,
    canBeUseOrg: undefined,
  })
  if (data.code === 0) {
    const resdata = data.data
    const newdata = resdata.map((item: any) => ({
      title: item.name,
      value: item.code,
    }))
    const action = setdataAction(newdata)
    yield put(action)
  }
}

// 导出当前模块的saga处理方法
export default function* jobmanagementsagas() {
  yield all([
    fork(alltask),
    // fork(setTest3),
  ])
}
